import Image from "next/legacy/image"
import Block from "@/components/wrappers/block"
import styles from "./icon.module.css"
import classNames from "classnames"

export default function icon({ block }) {
  if (!block.attrs.url) {
    return null
  }

  return (
    <Block block={block} className={classNames(styles.wrapper, "bmv-icon")}>
      <div className="relative w-full h-full">
        <Image
          src={block.attrs.url}
          layout="fill"
          objectFit="contain"
          objectPosition="center"
        />
      </div>
    </Block>
  )
}
